import type { Store } from 'redux';
import {
    createAsyncComponentWithReducer,
    getLogger,
    markPLTEvent,
    RequirePromiseBody,
} from '../../shared';
import * as ReactType from 'react';
import { lifecycle } from 'recompose';

// Need to export this to fix error TS4023
export { ReactType };

export const PeopleHubAsync = lifecycle({
    componentDidMount: () => markPLTEvent('PeopleHubMounted'),
})(
    createAsyncComponentWithReducer(async () => {
        try {
            const module = (await import(
                /* webpackChunkName: "PeopleHubBundle", webpackMode: "eager" */ './peopleHubLazyIndex'
            )) as RequirePromiseBody<{}>;
            markPLTEvent('PeopleHubResolved');
            return module;
        } catch (error) {
            // Loading js chuck has failed
            getLogger().log('ChuckLoadFailed', {
                component: 'peopleHub',
                error: error ? error.message : undefined,
            });
            return Promise.reject();
        }
    })
) as React.FunctionComponent<{ store: Store<{}> }>;
